import { render, staticRenderFns } from "./ConsentPatientTreatmentContract.vue?vue&type=template&id=b72ec57a"
import script from "./ConsentPatientTreatmentContract.vue?vue&type=script&lang=js"
export * from "./ConsentPatientTreatmentContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports